import ajax from "../utils/request";

const tagConfigsListApi = {
  // 新增标签配置
  addTagConfig(params) {
    return ajax({
      url: '/tag/conf/add',
      type: 'post',
      params
    })
  },
  // 删除标签配置
  delTagConfig(params) {
    return ajax({
      url: '/tag/conf/delete',
      type: 'post',
      params
    })
  },
  // 修改标签配置
  editTagConfig(params) {
    return ajax({
      url: '/tag/conf/update',
      type: 'post',
      params
    })
  }
}

export default tagConfigsListApi;